<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Marital Status" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-marital-status-form [maritalStatus]="maritalStatus" *ngIf="maritalStatus"></app-marital-status-form>
        </form>
      </div>
    </section>
  </div>
</div>


